<template lang="pug">
.curso-main-container.pb-3
  BannerInterno(icono="fas fa-sitemap" titulo="Síntesis")
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-2
        figure
          img.w-141.mb-4.mb-lg-0(src="@/assets/curso/sintesis/1.svg", alt="Ícono síntesis")
      .col-lg-10
        p El componente Distribución y promoción sostenible brinda herramientas para aplicar prácticas ecológicas en los procesos logísticos y de comunicación comercial. El aprendiz comprenderá cómo gestionar <em>stock</em> de forma eficiente y responsable con el entorno, conocerá los principios de los canales de distribución verde y su aplicación estratégica. Aprenderá a comunicar de manera coherente con valores sostenibles, diseñará campañas promocionales responsables y <em>marketing</em> con impacto ambiental positivo. En conjunto, desarrollará una visión comercial alineada con el desarrollo sostenible.
    .row.justify-content-center
      .col-lg-10.mb-5
        figure
          img(src="@/assets/curso/sintesis.svg", alt="El componente Distribución y promoción sostenible brinda herramientas para aplicar prácticas ecológicas en los procesos logísticos y de comunicación comercial. El aprendiz comprenderá cómo gestionar stock de forma eficiente y responsable con el entorno, conocerá los principios de los canales de distribución verde y su aplicación estratégica. Aprenderá a comunicar de manera coherente con valores sostenibles, diseñará campañas promocionales responsables y marketing con impacto ambiental positivo. En conjunto, desarrollará una visión comercial alineada con el desarrollo sostenible.")
      .col-auto
        a.anexo.mb-5(:href="obtenerLink('/downloads/Sintesis.pdf')" target="_blank")
          .anexo__icono
            img(src="@/assets/bullets/icono-pdf.svg")
          .anexo__texto
            p Anexo. Síntesis

</template>

<script>
export default {
  name: 'Sintesis',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
